import type { CommonStyledProps, GetStyles } from '@sds-system/types';

export const getCommonStyles: GetStyles<CommonStyledProps> = ({
  height,
  width,
  minHeight,
  minWidth,
  maxHeight,
  maxWidth,
}) => {
  return {
    height: height && height,
    width: width && width,
    minWidth: minWidth && minWidth,
    minHeight: minHeight && minHeight,
    maxHeight: maxHeight && maxHeight,
    maxWidth: maxWidth && maxWidth,
  };
};
